import { Text } from '@shopify/polaris'

import { AdaptiveModal } from '../common/AdaptiveModal'
import { DialogActivator } from '../common/helpers'

export const SkipInstallSubscriptionWidgetModal = ({
  modalActivator,
  handleModalClose,
  handleGoBack,
}: {
  modalActivator: DialogActivator
  handleModalClose: () => void
  handleGoBack: () => void
}) => {
  return (
    <AdaptiveModal
      open={modalActivator.open}
      onClose={handleModalClose}
      title="Add subscription widget"
      primaryAction={{
        content: 'Yes',
        onAction: handleModalClose,
      }}
      secondaryActions={[
        {
          content: 'Go back',
          onAction: handleGoBack,
        },
      ]}
    >
      <AdaptiveModal.Section>
        <Text as="p">
          Are you sure you want to skip adding the subscription widget? It's required to show
          subscription options in your store.
        </Text>
      </AdaptiveModal.Section>
    </AdaptiveModal>
  )
}
